export const NOT_SENT = 'NOT_SENT';
export const SENDING = 'SENDING';
export const SENT = 'SENT';
